import React from "react";
import { SvgIcon } from "@material-ui/core";
import { getFileExtension } from "@bonliva-crm/shared";
import {
  mdiFileCabinet,
  mdiFileMusic,
  mdiFileDocument,
  mdiFileImage,
  mdiFilePdfBox,
  mdiFile,
  mdiFilePowerpoint,
  mdiFileTable,
  mdiFileVideo
} from "../common/svgs";

const extensions = {
  archive: ["tar", "gz", "bz", "rar", "zip", "7z"],
  audio: ["wav", "mp3", "ogg", "flac"],
  doc: ["doc", "docx", "odt"],
  image: ["jpg", "jpeg", "gif", "png", "bmp", "tiff"],
  pdf: ["pdf"],
  slides: ["ppt", "pptx", "odp"],
  spreadsheet: ["xls", "xlsx", "ods"],
  video: ["avi", "mpg", "mpeg", "mp4"]
};

const fileTypeToIcon = {
  archive: makeSvgIcon(mdiFileCabinet),
  audio: makeSvgIcon(mdiFileMusic),
  doc: makeSvgIcon(mdiFileDocument),
  image: makeSvgIcon(mdiFileImage),
  pdf: makeSvgIcon(mdiFilePdfBox),
  file: makeSvgIcon(mdiFile),
  slides: makeSvgIcon(mdiFilePowerpoint),
  spreadsheet: makeSvgIcon(mdiFileTable),
  video: makeSvgIcon(mdiFileVideo)
};

function makeSvgIcon(path) {
  return (
    <SvgIcon fontSize="small">
      <path d={path} />
    </SvgIcon>
  );
}

export function getIconByFilename(name: string) {
  const ext = getFileExtension(name || "");
  const fileType = getFileType(ext);

  return fileTypeToIcon[fileType];
}

function getFileType(extension: string): string {
  let result = "file";
  let done = false;

  for (const key in extensions) {
    if (!done && extensions[key].includes(extension)) {
      result = key;
      done = true;
    }
  }

  return result;
}
